import React from 'react';
import { Typography } from '@mui/material';
import { openPartnerApp } from '../utils/ssoAuth';

export default function PartnerAppLink({ to = '/landlord', children, sx, ...props }) {
  const handleClick = (e) => {
    e.preventDefault();
    openPartnerApp(to);
  };

  return (
    <Typography
      component="a"
      href={to}
      onClick={handleClick}
      sx={sx}
      {...props}
    >
      {children}
    </Typography>
  );
}
